import { getCheckedValuesInObject } from 'utils';
import {
  DATA_ROOM_FAQ_ACCESS,
  DataRoomFaqAccessGranularityData,
  FAQAccessForm,
  FAQAccessInfo,
  FaqLeadStages,
} from '../../models/FAQ';

export const processFAQAccess = (
  values: FAQAccessForm,
  data: DataRoomFaqAccessGranularityData,
) => {
  const newValues = { faqAccess: values.faqAccess } as FAQAccessInfo;

  if (values.faqAccess === DATA_ROOM_FAQ_ACCESS.SPECIFIC) {
    const accessDataRoomBuySideMemberIds = getCheckedValuesInObject(
      values.accessDataRoomBuySideMemberIds,
    );

    newValues.accessDataRoomBuySideMemberIds = accessDataRoomBuySideMemberIds;
  }

  if (values.faqAccess === DATA_ROOM_FAQ_ACCESS.PARTICULAR_STAGE) {
    const faqAccessStages = getCheckedValuesInObject(
      values.faqAccessStages,
    ) as FaqLeadStages[];

    const accessDataRoomBuySideMemberIds = faqAccessStages
      .map((el) => data.particularStages?.[el] || [])
      .flat();

    newValues.faqAccessStages = faqAccessStages;
    newValues.accessDataRoomBuySideMemberIds = accessDataRoomBuySideMemberIds;
  }

  return newValues;
};

export const getFAQAccess = (values: FAQAccessInfo) => {
  const newValues = { faqAccess: values.faqAccess } as FAQAccessForm;

  if (values.faqAccess === DATA_ROOM_FAQ_ACCESS.SPECIFIC) {
    const accessDataRoomBuySideMemberIds =
      values.accessDataRoomBuySideMemberIds.reduce<Record<string, boolean>>(
        (acc, key) => {
          acc[key] = true;
          return acc;
        },
        {},
      );

    newValues.accessDataRoomBuySideMemberIds = accessDataRoomBuySideMemberIds;
  }

  if (values.faqAccess === DATA_ROOM_FAQ_ACCESS.PARTICULAR_STAGE) {
    const faqAccessStages = values.faqAccessStages.reduce<
      Record<string, boolean>
    >((acc, key) => {
      acc[key] = true;
      return acc;
    }, {});

    newValues.faqAccessStages = faqAccessStages;
  }

  return newValues;
};
